import React, {useState} from "react";

const TemplateInputName = (props) => {
    const [name,setName] = useState("");
    const handleChange = (e) => setName(e.target.value);
    return (
        <div className='input-details' > 
            <input onChange={handleChange}
                placeholder='Type your name'
                style={props.nameStyleObj} />
        </div>
    )};

export default TemplateInputName;
